module.exports = __webpack_public_path__ + "img/place.7c8ba0bf.png";